import styled from 'styled-components';
import Edit from '@carvana/icons/Edit';

export const Content = styled.div`
  background: #fff;
  border: 1px solid ${props => props.theme.color.neutral.v300};
  border-radius: 0.3rem;
  position: relative;
  height: 14.25rem;
  text-align: left;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-bottom: px;
  margin-bottom: 16px;
  height: 100%;
  width: 100%;

  @media (min-width: ${props => props.theme.breakpoint.sm}px) {
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 25px;
  }
`;

export const PanelHeader = styled.div`
  display: flex;
  border-bottom: 1px solid ${props => props.theme.color.neutral.v300};
  align-items: center;
  justify-content: space-between;
  height: 75px;
`;

export const Grid = styled.div`
  padding-top: 24px;
  display: flex;
  flex-direction: column;

  @media (min-width: ${props => props.theme.breakpoint.sm}px) {
    flex-direction: row;
  }
`;

export const Col = styled.div`
  flex-basis: 100%;

  @media (min-width: ${props => props.theme.breakpoint.sm}px) {
    flex-basis: 50%;
  }
`;

export const TextBox = styled.div`
  // &:not(:last-of-type) {
  //   padding-bottom: 10px;
  //  }
`;

export const EditButton = styled.a`
  color: ${props => props.theme.color.primary.v200};
  text-decoration: none;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 14px;
  line-height: 16px;
`;

export const Row = styled.div`
  display: flex;
  padding-top: 1rem;
  padding-bottom: 1.5rem;
  flex-direction: row;
  place-content: end space-between;
`;

export const Label = styled.div`
  color: ${props => props.theme.color.primary.v600};
  font-weight: bold;
  padding: 7px 0 7px 0;
  font-size: 14px;
`;

export const Data = styled.div`
   padding-bottom: 15px;
   font-size: 14px;
   color: ${props => props.theme.color.neutral.v500};
`;

export const Details = styled.div`
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  padding-top: 20px;
  padding-bottom: 20px;
  color: ${props => props.theme.color.primary.v600};
`;

export const Pencil = styled(Edit)`
  color: ${props => props.theme.color.primary.v200};
  cursor: pointer;

  & > svg {
    height: 20px;
    width: 20px;
  }
`;

